// extracted by mini-css-extract-plugin
module.exports = {"IdleTimeContainer":"IdleTime_IdleTimeContainer__RPtZY"};